import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Navbar from "./Navbar";
import { AiOutlineCopy } from "react-icons/ai";
import toast, { Toaster } from "react-hot-toast";

function Admin({ url, Dissconnect, Metamask, WalletC }) {
  useEffect(() => {
    PackagesDetails();
  }, []);

  const [crypt, setcryptos] = useState([]);

  const address = JSON.parse(localStorage.getItem("address"));

  const PackagesDetails = () => {
    try {
      axios.get(`${url}/api/crypto/address/${address}`).then((res) => {
        console.log("ges", res.data);
        setcryptos(res.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  console.log("url", url);

  const copyTextToClipboard = (text) => {
    notify("copied");
    return navigator.clipboard.writeText(text);
  };

  const notify = (msg) => toast.success(msg);
  const notifyError = (msg) => toast.error(msg);
  const notifyMessage = (msg) =>
    toast(msg, {
      duration: 10000,
    });

  return (
    <div>
      <Navbar Dissconnect={Dissconnect} Metamask={Metamask} WalletC={WalletC} />
      <div className="container-kws">
        <div className="section">
          <div className="t-a-c f-s-2 f-w-600  m-b-4">Request List</div>
          <div className="">
            {" "}
            <Paper
              sx={{
                width: "100%",
                overflow: "hidden",
                background: "transparent",
              }}
            >
              <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow className="f-w-600">
                      <TableCell
                        align="center"
                        style={{ minWidth: "170" }}
                        className="bg_d_b_clr"
                      >
                        Request Id
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ minWidth: "170" }}
                        className="bg_d_b_clr"
                      >
                        Email
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ minWidth: "170" }}
                        className="bg_d_b_clr"
                      >
                        Subject
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ minWidth: "170" }}
                        className="bg_d_b_clr"
                      >
                        Project Name
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ minWidth: "170" }}
                        className="bg_d_b_clr"
                      >
                        Status
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ minWidth: "170" }}
                        className="bg_d_b_clr"
                      >
                        View More
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {crypt &&
                      crypt.map((res, index) => {
                        return (
                          <>
                            <TableRow hover role="checkbox" tabIndex={-1}>
                              <TableCell
                                align="center"
                                style={{ minWidth: "170" }}
                              >
                                {res._id.slice(0, 4)}{" "}
                                <AiOutlineCopy
                                  onClick={() => copyTextToClipboard(res._id)}
                                  className="c-p"
                                />
                              </TableCell>
                              <TableCell align="center">{res.email}</TableCell>
                              <TableCell align="center">
                                {res.subject}
                              </TableCell>
                              <TableCell align="center">
                                {res.project_name}
                              </TableCell>
                              <TableCell align="center">
                                {res.status ? res.status : "Pending"}
                              </TableCell>
                              <TableCell align="center">
                                <Link
                                  to={`/request_list_detail/${res.project_api_name}/${res._id}`}
                                >
                                  <button className="bg_b_clr b-n b-r-5 pa-0_5 c-w">
                                    View More
                                  </button>
                                </Link>
                              </TableCell>
                            </TableRow>
                          </>
                        );
                      })}
                  </TableBody>
                </Table>
                {crypt.length > 0 ? (
                  ""
                ) : (
                  <div className="p-y-5 t-a-c c-w f-w-600">
                    No data to show.....
                  </div>
                )}
              </TableContainer>
            </Paper>
          </div>
        </div>
      </div>
      <Footer />
      <Toaster position="top-center" reverseOrder={true} />
    </div>
  );
}

export default Admin;
